import React from 'react'
import Layout from '../../components/about/Layout'
import routing from './../../helpers/routing'

export const About = props => {
  return <Layout onGoBackClick={() => routing.goBack(props)} />
}

export default About
